import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../MainPage.css';

const DetailsModal = ({ isOpen, onClose, project }) => {
    // Defensive check: if project is missing, don't render anything (even AnimatePresence)
    if (!project && isOpen) return null;

    return (
        <AnimatePresence>
            {isOpen && project ? (
                <div className="modal-overlay" onClick={onClose}>
                    <motion.div
                        className="modal-content glass-panel"
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    >
                        <button className="modal-close-btn" onClick={onClose}>&times;</button>
                        <h2 className="modal-title">{project?.title || 'Project Details'}</h2>
                        <p className="modal-dates">{project?.dates || "2024"}</p>

                        <div className="modal-section">
                            <h3>Overview</h3>
                            <p>{project?.longDescription || project?.description || 'No description available.'}</p>
                        </div>

                        {project?.stack && (
                            <div className="modal-section">
                                <h3>Tech Stack</h3>
                                <ul className="stack-list">
                                    {project.stack.map((item, index) => (
                                        <li key={index}>
                                            <span className="stack-category">{item.category}:</span> {item.details}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </motion.div>
                </div>
            ) : null}
        </AnimatePresence>
    );
};

export default DetailsModal;
